﻿import translations from '@eworx/ckeditor5/translations/en.js'
import emojiBaseDataMessages from 'emojibase-data/en/messages.json';
import emojis from 'emojibase-data/en/data.json';

const { groups } = emojiBaseDataMessages;

let emojiCategories = {};
groups.map(category => {
	emojiCategories[`EmojiCategory_${category.key}`] = category.message;
});

let emojiTranslations = {};
emojis.map(e => {
	emojiTranslations[`Emoji_${e.hexcode}`] = e.label;
});

translations.en.dictionary = {
	...translations.en.dictionary,
	'Choose placeholder': 'Choose placeholder',
	'Add statistic link': 'Add link',
	'Emoji': 'Emoji',
	'Emoji category': 'Emoji category',
	'Search emoji': 'Search emoji...',
	'EmojiCategory_All': 'All',
	'PicDefaultText': 'Picture',
	'insertMdbImage': 'Insert picture from mediadatabase',
	...emojiCategories,
	...emojiTranslations,
}

export default translations;